import { jsx as _jsx } from "react/jsx-runtime";
import { ProjectSummary } from '@widgets/projectSummary';
export function ProjectSummaryPage() {
    return _jsx(ProjectSummary, {});
}
